<template>
  <div :class="$style.toBeImportedUsersCounterSection">
    <h6 :class="$style.topTitle">
      To be imported
    </h6>
    <span :class="$style.toBeImportedUsers">{{ selectedItemsCount }}</span>
    <span :class="$style.toBeImportedUsersLabel">users</span>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapGetters } from 'vuex';

const storeModule = StoreModuleMap[ItemTypeConsts.scimUserImport];

export default {
  name: 'ScimToBeImportedUserCount',

  computed: {
    ...mapGetters(storeModule, {
      selectedItemsCount: 'getSelectedItemsCount',
    }),
  },
};
</script>

<style module>
@value ( jcGrey, jcGrey800 ) from '~css/brand-colors.css';

.toBeImportedUsersCounterSection {
  align-items: center;
  display: grid;
  font-size: 1.077rem;
  gap: 0 6px;
  grid-template:
    "title title" auto
    "toBeImportedUsers toBeImportedUsersLabel" auto / min-content 1fr;
  line-height: 1.286;
  margin: 0 1.15rem 0 0.4rem;
  text-align: left;
}

.topTitle {
  color: jcGrey;
  grid-area: title;
  margin: 0;
}

.toBeImportedUsers {
  color: jcGrey800;
  font-size: 1.38rem;
  font-weight: bold;
  grid-area: toBeImportedUsers;
  line-height: 1.28;
}

.toBeImportedUsersLabel {
  color: jcGrey800;
  font-weight: 600;
  grid-area: toBeImportedUsersLabel;
  line-height: 1.286;
}
</style>
